import { AdminGolfCourse, GolfCourseImage } from '../../../services/api';

export interface FormData {
  name: string;
  location: string;
  description: string;
  api_type: 'cps' | 'chronogolf';
  api_course_id: string;
  api_config: {
    [key: string]: any;
  };
  booking_url?: string;
  booking_advance_days: number;
  booking_open_time: string;
  // Golf course details
  holes?: number;
  length_yards?: number;
  par?: number;
  course_rating?: number;
  slope_rating?: number;
  course_type?: string;
  is_public?: boolean;
  facilities?: string[];
  features?: string[];
  address?: string;
  phone?: string;
  email?: string;
  website?: string;
}

export interface UploadingImage {
  id: string;
  file: File;
  progress: number;
  status: 'uploading' | 'completed' | 'error';
  url?: string;
  imageId?: number;
  error?: string;
}

export interface FormProps {
  course?: AdminGolfCourse | null;
  onSuccess: () => void;
  onCancel: () => void;
}

export interface FormSectionProps {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  isEditing: boolean;
  error: string | null;
  setError: React.Dispatch<React.SetStateAction<string | null>>;
}

export interface ApiConfigSectionProps extends FormSectionProps {
  validationResult: { valid: boolean; message: string } | null;
  setValidationResult: React.Dispatch<React.SetStateAction<{ valid: boolean; message: string } | null>>;
  showApiTypeDialog: boolean;
  setShowApiTypeDialog: React.Dispatch<React.SetStateAction<boolean>>;
  pendingApiType: 'cps' | 'chronogolf' | null;
  handleApiTypeChange: (apiType: 'cps' | 'chronogolf') => void;
}

export interface ImageManagementProps {
  course?: AdminGolfCourse | null;
  existingImages: GolfCourseImage[];
  setExistingImages: React.Dispatch<React.SetStateAction<GolfCourseImage[]>>;
  uploadingImages: UploadingImage[];
  setUploadingImages: React.Dispatch<React.SetStateAction<UploadingImage[]>>;
  deletingImageIds: Set<number>;
  setDeletingImageIds: React.Dispatch<React.SetStateAction<Set<number>>>;
  isReordering: boolean;
  setIsReordering: React.Dispatch<React.SetStateAction<boolean>>;
  error: string | null;
  setError: React.Dispatch<React.SetStateAction<string | null>>;
}

export interface ConfirmationDialogsProps {
  // API Type Dialog
  showApiTypeDialog: boolean;
  pendingApiType: 'cps' | 'chronogolf' | null;
  currentApiType: 'cps' | 'chronogolf';
  onConfirmApiTypeChange: () => void;
  onCancelApiTypeChange: () => void;
  
  // Exit Dialog
  showExitDialog: boolean;
  hasUnsavedChanges: boolean;
  existingImages: GolfCourseImage[];
  isLoading: boolean;
  onSaveAndExit: () => void;
  onConfirmExit: () => void;
  onCancelExit: () => void;
}

// Constants
export const BC_LOCATIONS = [
  'Vancouver, BC',
  'Burnaby, BC',
  'Richmond, BC',
  'Langley, BC',
  'Surrey, BC',
  'Furry Creek, BC',
  'Delta, BC'
];

export const COURSE_TYPES = [
  'Links',
  'Parkland', 
  'Heathland',
  'Desert',
  'Sandbelt',
  'Mountain',
  'Coastal/Ocean'
];

export const AVAILABLE_FACILITIES = [
  'Pro Shop',
  'Driving Range',
  'Putting Green',
  'Chipping Green',
  'Practice Bunker',
  'Restaurant',
  'Bar',
  'Clubhouse',
  'Locker Room',
  'Cart Rental',
  'Club Rental',
  'Lessons',
  'Tournament Hosting',
  'Banquet Facilities'
];

export const AVAILABLE_FEATURES = [
  'Water Hazards',
  'Sand Bunkers',
  'Tree-Lined Fairways',
  'Ocean View',
  'Mountain View',
  'Mature Trees',
  'Rolling Hills',
  'Links Style',
  'Parkland Style',
  'Championship Tees',
  'Multiple Tee Options',
  'Cart Paths',
  'Walking Friendly'
];

export const defaultCpsConfig = {
  baseUrl: '',
  siteId: '',
  websiteId: '',
  referer: ''
};

export const defaultChronogolfConfig = {
  baseUrl: 'https://www.chronogolf.com/marketplace/v2/teetimes',
  clubUrl: ''
};